import { MarketCountryCode } from '@backmarket/http-api'

export const DISPLAY_CATCHUP_MODAL_FOR_COUNTRY: Record<string, boolean> = {
  [MarketCountryCode.JP]: false,
  default: true,
}
